import { render, staticRenderFns } from "./avrefr.vue?vue&type=template&id=f46aceba&scoped=true&"
import script from "./avrefr.vue?vue&type=script&lang=js&"
export * from "./avrefr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46aceba",
  null
  
)

export default component.exports